import { Link, Text } from '@medly-components/core';
import { Logo } from 'components/common';
import { MANTA_CARES_SINCE } from 'constants/landing';
import { PRIVACY_POLICY, PRIVACY_POLICY_LINK, TERMS_AND_CONDITION, TERMS_AND_CONDITION_LINK } from 'constants/onboarding';
import type { FC } from 'react';
import { Footer, FooterLogoWrapper } from './MantaFooter.styled';

export const MantaFooter: FC = props => {
    return (
        <Footer {...props}>
            <FooterLogoWrapper>
                <Text>{MANTA_CARES_SINCE}</Text>
                <Logo blackLogo={true} />
            </FooterLogoWrapper>
            <Text>
                <Link target="_blank" href={PRIVACY_POLICY_LINK}>
                    {PRIVACY_POLICY}
                </Link>
                {' | '}
                <Link target="_blank" href={TERMS_AND_CONDITION_LINK}>
                    {TERMS_AND_CONDITION}
                </Link>
            </Text>
        </Footer>
    );
};

MantaFooter.displayName = 'LandingFooter';
